import {Component, OnInit, OnDestroy , ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-client-status',
  templateUrl: './client-status.component.html',
  styleUrls: ['./client-status.component.css']
})
export class ClientStatusComponent implements OnInit, OnDestroy {

  displayed = true;
  selected: number;
  columnDefinitions: any[];
  clients: any[];
  status: any[];
  clientSelected: number;

  show: boolean;
  dataset: any[];
  totalData: number;
  selectedTitles: any[];
  private respObject: any;
  private statusName: any;
  statusDesc: string;
  private clientName: any;
  displayData: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  private clientId: number;
  private seq: any;
  private stopSlaMeter: boolean;
  nextOffset: number;
  previousOffset: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private baseFlag: any;
  private adminAuth: Subscription;
  offset: number;
  dataLoaded:boolean;
  showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    statusSelected: any;
    adminstatus: any;
    des: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;
    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


  constructor(private _rest: RestApiService, private messageService: MessageService,
              private route: Router, private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (!this.del) {
            this.notifier.notify('error', 'You do not have delete permission');
          } else {
            if (confirm('Are you sure?')) {
              this._rest.deleteTicketAttributesClientWise({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                this.respObject = res;
                // console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                  this.messageService.sendAfterDelete(item.id);
                } else {
                  this.notifier.notify('error', this.respObject.errorMessage);
                }
              }, (err) => {
                this.notifier.notify('error', this.respObject.errorMessage);
              });
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      // console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      } else {
        this.add = false;
        this.del = false;
        this.view = false;
        this.edit = false;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }


  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.pageSize = this.messageService.pageSize;
    this.page_no = 0;
    this.totalPage = 0;
    this.paginationType = 'next';
    this.displayData = {
      pageName: 'Maintain Client Mapping With Status',
      openModalButton: 'Add Client Status Map',
      searchModalButton: 'Search',
      breadcrumb: 'ClientStatusMap',
      folderName: 'All Client Status Map',
      tabName: 'Client Status Map',
      exportBtn: 'Export to excel'


    };

    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'status', name: 'Status', field: 'name', sortable: true, filterable: true
      },
      {
        id: 'clientname', name: 'Client', field: 'client', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    this._rest.getClient().subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.respObject.clients.unshift({id: 0, name: 'Select Client'});
        this.clients = this.respObject.clients;
        this.clientSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, function (err) {

    });
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
  }

  onPageLoad() {
        this._rest.getStatus(this.clientId).subscribe((res) => {
          this.respObject = res;
          // console.log(JSON.stringify(this.respObject));
          if (this.respObject.success) {
            this.isError = false;
            // this.respObject.details.unshift({id: 0, name: 'Select Status'});
            this.status = this.respObject.details;
          } else {
            this.isError = true;
            this.errorMessage = this.respObject.errorMessage;
          }
        });
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  exportToExcel() {
    this.isExportDisable = true;

    // console.log("okkk" +this.clientId);
    this._rest.getAllClientStatus(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;

            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}


  openModal(content) {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.clientSelected = 0;
      this.modalService.open(content, {size: 'sm'}).result.then((result) => {
      }, (reason) => {

      });
    }
  }
  searchModal() {
    if (!this.add) {
      this.notifier.notify('error', 'You do not have add permission');
    } else {
      this.isError = false;
      this.clientSelected = 0;
      this.statusSelected = '';
      this.searchModalReference = this.modalService.open(this.scarch_content);
      this.searchModalReference.result.then((result) => {
      }, (reason) => {

      });
}
  }


  search() {
    this._rest.searchAllClientStatus(this.statusSelected, this.clientId).subscribe((res1) => {
        this.respObject = res1;
        this.isLoading = false;
        if (this.respObject.success) {
            this.adminstatus = this.respObject.details;
            this.messageService.setTotalData(this.adminstatus.length);
            this.messageService.setGridData(this.adminstatus);
            this.searchModalReference.close();

        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.isLoading = false;
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}


    get selectedStatus() {
        return this.status
            .filter(opt => opt.checked)
            .map(opt => opt);

    }

  save() {
    const arrayStatus = [];
    for (let i = 0; i < this.selectedStatus.length; i++) {
        arrayStatus.push(this.selectedStatus[i]);
    }
    // console.log('arrayStatusssssssssssss ' + JSON.stringify(arrayStatus));
    const data = {
      clientId: this.clientSelected,
      attrId: 2,
      arrayStatus: arrayStatus,
      createdBy: this.messageService.getUserId()
    };
    // console.log(JSON.stringify(data));
    if (!this.messageService.isBlankField(data)) {
      // data['seq'] = this.seq;
      this._rest.insertTicketAttributesClientWise(data).subscribe((res) => {
        this.respObject = res;
        // console.log('resobj=====' + JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.isError = false;
          this.nextOffset = 0;
          this.page_no = 0;
          this.getTableData();
          this.clientSelected = 0;
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  getTableData() {
    if (!this.view) {
      this.notifier.notify('error', 'You do not have view permission');
    } else {
      this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded=false;

    this._rest.getMappedStatus(offset, this.pageSize, paginationType).subscribe((res) => {
      this.respObject = res;
      this.executeResponse(this.respObject, offset, paginationType);
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  onClientChange(index: any) {
    this.clientName = this.clients[index].name;
  }

  // onTicketChange(index: any) {
  //   this.statusName = this.status[index].name;
  //   this.statusDesc = this.status[index].description;
  //   this.seq = this.status[index].seq;
  //   this.stopSlaMeter = this.status[index].stopSlaMeter;
  // }

  ngOnDestroy(): void {
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }


}
